<template>
    <div
        v-if="zipNotEntered"
        class="d-flex flex-column align-items-center justify-content-center h-100 text-center px-3"
    >
        <p class="font-size-md mb-2">Provide your location to view Map.</p>
        <button class="btn btn-xs btn-primary" @click="enterLocation()">ENTER LOCATION</button>
    </div>
    <div v-else class="h-100" id="Employee__VisitMap">
        <div class="d-flex w-100 justify-content-center mt-4">
            <i class="fas fa-spinner fa-pulse fa-fw"></i>
            <b class="mx-2">Waiting for your location</b>
            <i class="fas fa-spinner fa-pulse fa-fw"></i>
        </div>
    </div>
</template>

<script lang="ts" src="./EmployeeVisitMap.ts"></script>
<style src="./EmployeeVisitMap.scss"></style>
